module.exports = __webpack_public_path__ + "img/ostage_chairline.e890607d.jpg";